document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.video-wrapper').forEach(wrapper => {
		const video = wrapper.querySelector('video')
		if (!video) return

		const fullscreenControl = wrapper.querySelector('.fullscreen-control')
		if (fullscreenControl) {
			fullscreenControl.addEventListener('click', e => {
				e.preventDefault()

				if (video.webkitRequestFullscreen) {
					video.webkitRequestFullscreen()
				} else {
					video.requestFullscreen()
				}
			})
		}

		const audioControl = wrapper.querySelector('.audio-control')
		if (audioControl) {
			audioControl.addEventListener('click', e => {
				e.preventDefault()

				video.muted = !video.muted
				audioControl.classList.toggle('unmuted', !video.muted)
			})
		}
	})
})
